import { ROLES } from "../../../helpers/commons.helpers";

/**
 * Dashboard route definitions.
 *
 * These route definitions are lazy-loaded and intended to be used as children
 * of the authenticated layout. The `meta` object may include the following
 * properties used by navigation guards and permission checks:
 *
 * @typedef {Object} DashboardRouteMeta
 * @property {boolean} [requiresAuth=false] - When true, the route requires an authenticated session.
 * @property {Array<string>} [roles=[]] - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "dashboard",
        name: "Dashboard",
        meta: {
            title: "Dashboard",
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN]
        },
        component: () =>
            import(/* webpackChunkName: "metrics" */ "@/modules/metrics/pages/Dashboard.vue")
    }
]